import { createSlice, type PayloadAction } from "@reduxjs/toolkit"

export interface FormSubmission {
  id: string
  reportId: string
  reportName: string
  submissionData: Record<string, any>
  submittedAt: string
  submittedBy: string
  status: "submitted" | "draft" | "reviewed"
}

interface SubmissionState {
  submissions: FormSubmission[]
  currentSubmission: FormSubmission | null
}

const initialState: SubmissionState = {
  submissions: [],
  currentSubmission: null,
}

const submissionSlice = createSlice({
  name: "submissions",
  initialState,
  reducers: {
    addSubmission: (state, action: PayloadAction<Omit<FormSubmission, "id" | "submittedAt">>) => {
      const newSubmission: FormSubmission = {
        ...action.payload,
        id: `submission_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
        submittedAt: new Date().toISOString(),
      }
      state.submissions.push(newSubmission)
    },
    updateSubmission: (state, action: PayloadAction<FormSubmission>) => {
      const index = state.submissions.findIndex((sub) => sub.id === action.payload.id)
      if (index !== -1) {
        state.submissions[index] = action.payload
      }
    },
    deleteSubmission: (state, action: PayloadAction<string>) => {
      state.submissions = state.submissions.filter((sub) => sub.id !== action.payload)
    },
    setCurrentSubmission: (state, action: PayloadAction<FormSubmission | null>) => {
      state.currentSubmission = action.payload
    },
    setSubmissions: (state, action: PayloadAction<FormSubmission[]>) => {
      state.submissions = action.payload
    },
  },
})

export const { addSubmission, updateSubmission, deleteSubmission, setCurrentSubmission } = submissionSlice.actions
export default submissionSlice.reducer
